<template>
  <ContentCard title="院内采购">
    <!-- 开标项目 -->
    <!-- <ProjectList style="margin-bottom: 16px"/> -->

    <!-- 公告 -->
    <NoticeList style="margin-bottom: 16px"/>

    <!-- 公示 -->
    <PublicityList />
  </ContentCard>
</template>

<script>
import ContentCard from '@/components/ContentCard'
import NoticeList from './NoticeList.vue'
import ProjectList from './ProjectList.vue'
import PublicityList from './PublicityList.vue'

export default {
	name: "SystemNotice",
  components: { ContentCard, ProjectList, NoticeList, PublicityList },
  data() {
    return {
    }
  },
  methods: {
  }
};
</script>

<style lang="less" scoped>
</style>
